import {
  getAnchorButtonUrlProps,
  toSlug,
  trackAnalytics,
} from '../utils';

export const mapBackendButtonToFEButton = ({
  button = null,
  locale = 'en',
  analyticsParentId = '',
  analyticsTags = null,
  fallback = {},
}) => {
  if (!button) {
    return null;
  }

  const {
    label,
    href,
    descriptiveText,
    openInNewTab,
    variant,
    size,
    theme,
  } = button;

  const {
    buttonText: fallbackButtonText = '',
    accessibleLabel: fallbackAccessibleLabel = '',
    variant: fallbackVariant = 'secondary',
    size: fallbackSize = 'medium',
    theme: fallbackTheme = 'light',
  } = fallback;

  const { url } = getAnchorButtonUrlProps(href, locale);
  const buttonText = label || fallbackButtonText;
  const accessibleLabel = descriptiveText || fallbackAccessibleLabel;
  const analytics = analyticsParentId && buttonText
    ? trackAnalytics(
      analyticsParentId,
      `${toSlug(buttonText)}-${analyticsParentId}`,
      url,
      analyticsTags,
    )
    : {};

  return {
    buttonText,
    accessibleLabel,
    url,
    variant: variant || fallbackVariant,
    size: size || fallbackSize,
    theme: theme || fallbackTheme,
    ...(openInNewTab ? { target: '_blank' } : {}),
    ...analytics,
  };
};
